"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Link from "next/link";

export function CookieAccept() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = document.cookie
      .split("; ")
      .some((c) => c.startsWith("accepted=true"));
    if (!accepted) {
      // Небольшая задержка чтобы не мелькало при загрузке
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    document.cookie = "accepted=true; path=/; max-age=31536000; SameSite=Lax";
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed bottom-4 left-4 right-4 z-50 flex justify-center"
          initial={{ opacity: 0, y: 20, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          exit={{ opacity: 0, y: 10, filter: "blur(8px)" }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="max-w-xl w-full rounded-2xl border bg-black/90 backdrop-blur-xl px-6 py-4 flex flex-col sm:flex-row items-center gap-4 shadow-2xl">
            <p className="text-sm text-white/60 text-center sm:text-left">
              Пользуясь сайтом, вы соглашаетесь с использованием{" "}
              <Link
                href="/cookies"
                className="text-purple-400 underline hover:text-purple-300 transition-colors"
              >
                cookies
              </Link>
            </p>
            <button
              onClick={handleAccept}
              className="shrink-0 px-6 py-2 rounded-lg bg-white text-black text-sm font-semibold hover:bg-white/90 transition-colors cursor-pointer"
            >
              Хорошо
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
